import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);
    (async () => {
      try {
        const { data } = await api.post("/auth/emergent/session", null, {
          headers: { "X-Session-ID": sessionId },
        });
        setUser(data);
        // Clean hash and redirect based on role
        const dest = data?.role === "admin" ? "/admin" : data?.role === "club" ? "/club/dashboard" : "/dashboard";
        window.history.replaceState(null, "", dest);
        navigate(dest, { replace: true, state: { user: data } });
      } catch (e) {
        console.error("emergent session exchange failed", e);
        navigate("/login?err=oauth", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-jpa-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="font-display text-3xl tracking-widest text-jpa-primary">Signing you in…</p>
      </div>
    </div>
  );
}
